export default "/_next/static/media/Screen-Shot-2021-02-21-at-7.32.40-AM-1024x377.fa1d2a0ee58ff5fb344f99d09f6c1a54.png";